import { createContext } from 'react';
import { AllUsersQuery, OrganizationPublicInfoQuery, ProfileQuery } from '@graphql/admin/generated/graphql.types';

export type AdminPortalContextValue = {
  loading: boolean;
  profile: ProfileQuery['profile'];
  orgPublicInfo: OrganizationPublicInfoQuery['organizationPublicInfo'];
  users: AllUsersQuery['allUsers']['edges'];
}

export const adminPortalContextDefaultValue = {
  loading: true,
  profile: null,
  orgPublicInfo: null,
  users: null,
}

export const AdminPortalContext = createContext<AdminPortalContextValue>(adminPortalContextDefaultValue);